<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3.75C7.30964 3.75 6.75 4.30964 6.75 5V5.25H17.25V5C17.25 4.30964 16.6904 3.75 16 3.75H8ZM18.75 5.25V5C18.75 3.48122 17.5188 2.25 16 2.25H8C6.48122 2.25 5.25 3.48122 5.25 5V5.25H4.00071C3.5865 5.25 3.25 5.58579 3.25 6C3.25 6.41421 3.58579 6.75 4 6.75H20C20.4142 6.75 20.75 6.41421 20.75 6C20.75 5.58579 20.4142 5.25 20 5.25H18.75ZM6 8.25C6.41421 8.25 6.75 8.58579 6.75 9V19.5C6.75 20.1904 7.30964 20.75 8 20.75H16C16.6904 20.75 17.25 20.1904 17.25 19.5V9C17.25 8.58579 17.5858 8.25 18 8.25C18.4142 8.25 18.75 8.58579 18.75 9V19.5C18.75 21.0188 17.5188 22.25 16 22.25H8C6.48122 22.25 5.25 21.0188 5.25 19.5V9C5.25 8.58579 5.58579 8.25 6 8.25ZM10 10.25C10.4142 10.25 10.75 10.5858 10.75 11V18C10.75 18.4142 10.4142 18.75 10 18.75C9.58579 18.75 9.25 18.4142 9.25 18V11C9.25 10.5858 9.58579 10.25 10 10.25ZM14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V18C14.75 18.4142 14.4142 18.75 14 18.75C13.5858 18.75 13.25 18.4142 13.25 18V11C13.25 10.5858 13.5858 10.25 14 10.25Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGDelete',
};
</script>

<style scoped lang="scss">

</style>
